import {
  Box,
  FormControlLabel,
  FormGroup,
  Paper,
  Stack,
  Switch,
} from "@mui/material";
import { AppState } from "store/types";
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import "./PromoTypeFilterStyles.css";
import { PromoTypeItem } from "store/promotionCalendar/types";
import { updatePromoTypeList } from "store/promotionCalendar/promotionCalendar.slice";

const PromoTypeFilter = ({}) => {
  const dispatch = useDispatch();
  const ref = useRef();

  const promoTypeList = useSelector(
    (state: AppState) => state.promotionCalendar.promoTypeList
  );

  const [promoTypes, setPromoTypes] = useState<PromoTypeItem[]>(promoTypeList);
  const [open, setOpen] = useState<boolean>(false);

  const handleChange = (id: number) => {
    const newPromoTypes = promoTypes.map((promoTypeItem) =>
      promoTypeItem.id === id
        ? { ...promoTypeItem, checked: !promoTypeItem.checked }
        : promoTypeItem
    );
    setPromoTypes(newPromoTypes);
  };

  useEffect(() => {
    if (promoTypes) {
      dispatch(updatePromoTypeList(promoTypes));
    }
  }, [promoTypes]);

  useEffect(() => {
    const handler = (e: any) => {
      //@ts-ignore
      if (!ref?.current?.contains(e?.target)) {
        setOpen(false);
      }
    };

    document.addEventListener("mousedown", handler);
    return () => {
      document.removeEventListener("mousedown", handler);
    };
  });

  return (
    <Stack
      direction="row"
      spacing={2}
      sx={{
        position: "absolute",
        right: "0",
        zIndex: "20",
        left: "0",
        width: "229px",
        margin: "0 auto",
      }}
    >
      <Paper
        elevation={3}
        sx={{
          width: "250px",
          //padding: "12px",
          position: "relative",
          left: "8px",
          borderRadius: "8px",
          marginTop: "3px",
          zIndex: 2,
        }}
      >
        <Box
          sx={{
            maxHeight: "300px",
          }}
          ref={ref}
        >
          <FormGroup>
            {promoTypes.map((promoTypeItem) => (
              <FormControlLabel
                sx={{
                  fontFamily: "Lato",
                  fontStyle: "normal",
                  fontWeight: 400,
                  fontSize: "10px",
                  display: "flex",
                  background: promoTypeItem?.checked
                    ? "white"
                    : "rgba(238, 238, 238, 1)",
                  justifyContent: "space-between",
                  padding: "0 12px",
                  alignItems: "center",
                  color: "#757575",
                  margin: "0",
                }}
                control={
                  <Switch
                    sx={{
                      fontFamily: "Lato",
                    }}
                    checked={promoTypeItem.checked}
                    onChange={() => handleChange(promoTypeItem.id)}
                  />
                }
                label={
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "8px",
                    }}
                  >
                    <div
                      style={{
                        width: "12px",
                        height: "12px",
                        background: promoTypeItem.color,
                        borderRadius: "1px",
                      }}
                    ></div>
                    <span
                      style={{
                        fontFamily: "Lato",
                        fontStyle: "normal",
                        fontWeight: "400",
                        fontSize: "14px",
                        lineHeight: "17px",
                        color: "#424242",
                      }}
                    >
                      {promoTypeItem.name}
                    </span>
                  </div>
                }
                labelPlacement="start"
                key={promoTypeItem.id}
              />
            ))}
          </FormGroup>
        </Box>
      </Paper>
    </Stack>
  );
};

export default PromoTypeFilter;
